import { Box, Flex, List, ListItem, SimpleGrid } from '@chakra-ui/react';
import React, { useState } from 'react';
import HtmlParser from '../HtmlParser/HtmlParser';
import Text from '../Text';
export var CLASS_TYPE_VALUES = {
  adult: 'Adulte',
  junior: 'Junior',
  profesional: 'Professionnel',
  student: 'Étudiant'
};
export var INTENSIVITY_VALUES = {
  'activity-and-class': 'Cours de langue + activité',
  'exam-prep': 'Préparation à un test',
  'one-to-one': 'Cours particuliers',
  'semi-intensive': 'Semi-intensifs',
  'super-intensive': 'Cours super intensifs',
  academic: 'Cours de langue académique',
  business: 'Cours de langue des affaires',
  intensive: 'Intensifs',
  online: 'Cours en ligne',
  professionnel: 'Cours professionnel et cadre'
};
export var CLASS_FORMAT_VALUES = {
  group: 'En groupe',
  online: 'En ligne',
  private: 'Particulier'
};

var ProgramTabs = function ProgramTabs(props) {
  var _props$tabs, _props$tabs2;

  var _useState = useState(0),
      activeTabIndex = _useState[0],
      setActiveTabIndex = _useState[1];

  var INTENSIVITY = 'Intensité des cours : ';
  var CLASS_TYPE_LABEL = 'Type de cours : ';
  return /*#__PURE__*/React.createElement(Flex, {
    w: "100%",
    minHeight: "600px",
    direction: {
      base: 'column',
      xl: 'row'
    }
  }, /*#__PURE__*/React.createElement(List, {
    width: {
      base: '100%',
      xl: 270
    },
    display: {
      base: 'block',
      md: 'flex',
      xl: 'block'
    },
    justifyContent: "space-evenly",
    position: "relative",
    h: "fit-content",
    bg: "primary.500",
    py: {
      base: 4,
      xl: 12
    },
    pl: {
      base: 6,
      xl: 116
    },
    sx: {
      '& > *': {
        mt: 2
      }
    },
    borderTop: {
      base: function base(theme) {
        return "4px " + theme.colors.secondary['500'] + " solid";
      },
      md: 'none'
    },
    _before: {
      base: 'none',
      xl: {
        borderLeft: '1px solid white',
        content: '""',
        display: 'block',
        height: '100%',
        left: '78px',
        position: 'absolute',
        top: 0
      }
    }
  }, (_props$tabs = props.tabs) === null || _props$tabs === void 0 ? void 0 : _props$tabs.map(function (tab, index) {
    return /*#__PURE__*/React.createElement(ListItem, Object.assign({
      key: tab === null || tab === void 0 ? void 0 : tab.title,
      onClick: function onClick() {
        return setActiveTabIndex(index);
      },
      fontSize: "18px",
      color: "secondary.500",
      textTransform: "uppercase",
      cursor: "pointer",
      position: "relative",
      fontWeight: activeTabIndex === index ? 'bold' : 'normal',
      _hover: {
        transform: activeTabIndex === index ? 'none' : 'translateY(-1px)'
      }
    }, activeTabIndex === index ? {
      _before: {
        content: '"»"',
        left: -5,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-55%)'
      }
    } : {}), /*#__PURE__*/React.createElement(Flex, {
      align: "center"
    }, tab === null || tab === void 0 ? void 0 : tab.title));
  })), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    px: {
      base: 4,
      xl: 24
    },
    pt: {
      base: 4,
      xl: 12
    }
  }, (_props$tabs2 = props.tabs) === null || _props$tabs2 === void 0 ? void 0 : _props$tabs2.map(function (tab, index) {
    var _props$languageClassC, _tab$featuresList;

    if (!tab) return null;
    return /*#__PURE__*/React.createElement(Box, {
      key: tab === null || tab === void 0 ? void 0 : tab.title,
      display: activeTabIndex === index ? 'block' : 'none'
    }, /*#__PURE__*/React.createElement(Text, {
      as: "h3",
      fontSize: 40,
      fontWeight: "900",
      textTransform: "uppercase",
      textAlign: "center",
      mb: 4
    }, tab === null || tab === void 0 ? void 0 : tab.title), 'classesIntensity' in tab && tab.classesIntensity ? /*#__PURE__*/React.createElement(Flex, {
      wrap: "wrap",
      mb: 4,
      bg: "primary.100"
    }, /*#__PURE__*/React.createElement(Flex, {
      mr: 8,
      align: "baseline"
    }, /*#__PURE__*/React.createElement(Text, {
      textTransform: "uppercase",
      fontSize: "sm",
      fontWeight: "900"
    }, INTENSIVITY), /*#__PURE__*/React.createElement(Text, {
      ml: 2
    }, tab.classesIntensity.map(function (classesIntensity) {
      return INTENSIVITY_VALUES[classesIntensity];
    }).join(', '))), /*#__PURE__*/React.createElement(Flex, {
      align: "baseline"
    }, /*#__PURE__*/React.createElement(Text, {
      textTransform: "uppercase",
      fontSize: "sm",
      fontWeight: "900"
    }, CLASS_TYPE_LABEL), /*#__PURE__*/React.createElement(Text, {
      ml: 2
    }, (_props$languageClassC = props.languageClassCategory) === null || _props$languageClassC === void 0 ? void 0 : _props$languageClassC.map(function (classCategory) {
      if (!classCategory) return; // @ts-ignore GraphQL cannot define

      return CLASS_TYPE_VALUES[classCategory];
    }).join(', ')))) : null, /*#__PURE__*/React.createElement(HtmlParser, {
      maxWidth: "100%",
      textBlock: true
    }, tab === null || tab === void 0 ? void 0 : tab.text), /*#__PURE__*/React.createElement(SimpleGrid, {
      spacing: 8,
      minChildWidth: 140,
      mt: 8,
      justifyItems: "center"
    }, tab === null || tab === void 0 ? void 0 : (_tab$featuresList = tab.featuresList) === null || _tab$featuresList === void 0 ? void 0 : _tab$featuresList.map(function (feature, index) {
      return /*#__PURE__*/React.createElement(Text, {
        textVariant: "h4",
        fontSize: "sm",
        fontWeight: "bold",
        maxWidth: "200px",
        textAlign: "center",
        key: "feature+" + index
      }, feature === null || feature === void 0 ? void 0 : feature.title);
    })));
  })));
};

export default ProgramTabs;